import type {
  roomPkActionInterface,
  roomPkInterface,
  roomPkResultInterface,
  roomPkScoreInterface
} from '~/types/apiType/roomPkType'

// 房间PK倒计时时长 6min
const PK_TIME = 6 * 60 * 1000
// 惩罚时长 2min
const PENALTY_TIME = 2 * 60 * 1000
// 开始PK倒计时时长 4s
const PK_START_TIME = 4 * 1000

// 房间PK
export const useRoomPkStore = defineStore({
  id: 'roomPk',
  // PK流程 发起 -> ready -> action -> result -> penalty -> 结束，回到视频房
  state: () => ({
    isInPk: false, // 是否在房间PK中
    isStartPk: false, // 是否已开始PK
    isPenaltyTime: false, // 是否正在PK惩罚中（PK结算）
    pkCountdown: 0, // 房间PK倒计时
    roomPkInfo: {} as roomPkInterface, // 房间PK信息
    roomPkScoreInfo: {} as roomPkScoreInterface, // 房间PK送礼信息
    roomPkResultInfo: {} as roomPkResultInterface, // 房间PK结果
    soundStatus: {
      // sound: true,
      // 对面主播麦位状态是否在切换中
      isSwitching: false
    }
  }),
  actions: {
    /**
     * 关闭/打开对面主播的声音(仅主播可操作)
     */
    async switchSound() {
      if (this.soundStatus.isSwitching) return
      const audioStore = useAudioStore()
      if (!audioStore.isCreator) return
      this.soundStatus.isSwitching = true
      const position = 1
      const state = audioStore.queueList[constant.ROOM_PK_MIC_INDEX]?.value
        ?.mic_info?.micState
        ? 1
        : 0
      await audioStore.lockMic(position, state ? 0 : 1)
      this.soundStatus.isSwitching = false
    },
    // 初始化PK信息，刚进房已经在PK中
    initRoomPkInfo(scoreInfo: roomPkScoreInterface, data: roomPkInterface) {
      this.resetData()
      this.isInPk = true
      // 已开始PK
      if (scoreInfo.durationSecond && scoreInfo.durationSecond > 0) {
        this.isStartPk = true
        this.pkCountdown =
          PK_TIME - scoreInfo.durationSecond * 1000 + PK_START_TIME

        // 已结束，在惩罚阶段
        if (
          scoreInfo.pkResult === constant.ROOM_PK_RESULT.WIN ||
          scoreInfo.pkResult === constant.ROOM_PK_RESULT.LOSE
        ) {
          this.isPenaltyTime = true
          this.pkCountdown =
            PK_TIME +
            PENALTY_TIME -
            scoreInfo.durationSecond * 1000 +
            PK_START_TIME
        }
      }
      this.roomPkResultInfo = {
        otherRoomId: data.pkRoomId,
        result: scoreInfo.pkResult ?? constant.ROOM_PK_RESULT.DRAW,
        runningRecordId: data.runningRecordId
      }
      this.roomPkScoreInfo = scoreInfo
      this.roomPkInfo = data
    },
    // 匹配成功
    onRoomMatchPkReady(data: roomPkInterface) {
      this.resetData()
      this.isInPk = true
      this.roomPkInfo = data
      // 主播开始跨频道媒体流转发
      // const agoraStore = useAgoraStore()
      // agoraStore.startChannelMediaRelay(data)
    },
    // PK开始
    onRoomMatchPkAction(data: roomPkActionInterface) {
      this.isStartPk = true
      setTimeout(() => {
        this.pkCountdown = PK_TIME
      }, PK_START_TIME)
    },
    // PK送礼值更新
    onRoomMatchPkScore(data: roomPkScoreInterface) {
      this.roomPkScoreInfo = data
    },
    // PK结果
    onRoomMatchPkResult(data: roomPkResultInterface) {
      const audioStore = useAudioStore()
      const i18n = useNuxtApp().$i18n
      if (
        (data.result === constant.ROOM_PK_RESULT.WIN ||
          data.result === constant.ROOM_PK_RESULT.LOSE) &&
        // 判断PK结束是否为提前退出，退出时会先发下麦通知
        audioStore.queueList[constant.ROOM_PK_MIC_INDEX]?.value?.member
      ) {
        this.isPenaltyTime = true
        this.pkCountdown = PENALTY_TIME
      } else {
        this.isInPk = false
        this.isStartPk = false
        this.roomPkInfo = {} as roomPkInterface
      }
      this.roomPkResultInfo = data
      // 提交事件 展示PK结果
      emitter.emit(EmitterEventType.SHOW_PK_RESULT, data.result)

      // 房主逻辑
      if (audioStore.isCreator) {
        // 结果提示
        const toastMap = {
          [constant.ROOM_PK_RESULT.WIN]: i18n.t('room.WillWin'),
          [constant.ROOM_PK_RESULT.LOSE]: i18n.t('room.WillLose'),
          [constant.ROOM_PK_RESULT.DRAW]: i18n.t('room.WillDraw')
        }
        toastMap[data.result] &&
          showToast({
            message: toastMap[data.result],
            position: 'bottom'
          })
        // 主播停止跨频道媒体流转发
        // const agoraStore = useAgoraStore()
        // agoraStore.stopChannelMediaRelay()
      }
    },
    // 重置数据
    resetData() {
      this.isInPk = false
      this.isStartPk = false
      this.isPenaltyTime = false
      this.pkCountdown = 0
      this.roomPkInfo = {} as roomPkInterface
      this.roomPkScoreInfo = {} as roomPkScoreInterface
      this.roomPkResultInfo = {} as roomPkResultInterface
      this.soundStatus = { isSwitching: false }
    }
  }
})
